import type { ProgramStatus } from '../program-actions-menu';

/**
 * Map a Core statusKey to the UI ProgramStatus type. Shared by the three
 * program-edit step containers (info / benefits / faqs) so the header badge
 * and the EU-570 read-only gate see the SAME status everywhere — before
 * EU-570, benefits/faqs hardcoded `'ativa'` and the badge lied for
 * encerrado/cancelado.
 */
export function mapProgramStatusKey(
  statusKey: 'not_published' | 'private' | 'published' | 'cancelled' | 'inactivated' | 'expired'
): ProgramStatus {
  if (statusKey === 'published') return 'ativa';
  if (statusKey === 'private') return 'ativo-privado';
  if (statusKey === 'cancelled') return 'cancelado';
  if (statusKey === 'inactivated') return 'encerrado';
  // 'expired' — published/private program past its `endApplying` window,
  // derived in the BFF (see recruiter `program-status.ts`).
  if (statusKey === 'expired') return 'encerrado';
  return 'rascunho';
}

/**
 * EU-570 — programas Encerrados ou Cancelados abrem o fluxo de edição em modo
 * SOMENTE VISUALIZAÇÃO: todos os campos/cards desabilitados, tooltip "Edição
 * bloqueada", "Avançar" só navega e "Salvar alterações" (última etapa) fica
 * desabilitado. A cópia (rascunho duplicado) nunca é read-only.
 */
export function isProgramReadOnly(status: ProgramStatus): boolean {
  return status === 'encerrado' || status === 'cancelado';
}
